import { PdpProductSizeType, RecommendOptionValueList, SizeRecommendation } from '@domains/pdp-common';

import { RecommendOptionValueModel, SizeRecommendationModel } from '../utils/types';

function getUserBodySizeText(body?: { height?: number; weight?: number; size_text?: string | null } | null): string {
  // size_text가 있으면 우선 사용 (신발 등)
  if (body?.size_text) {
    return body.size_text;
  }

  const height = body?.height || 0;
  const weight = body?.weight || 0;

  if (height > 0 && weight > 0) {
    return `${height}cm · ${weight}kg`;
  }

  return '';
}

function toUserAccountBody(body?: { height?: number; weight?: number; size_text?: string | null } | null) {
  const height = body?.height || 0;
  const weight = body?.weight || 0;
  const sizeText = getUserBodySizeText(body);

  // 유효한 체형 정보가 없으면 null 반환
  // - 의류: 키, 몸무게 둘 다 있어야 유효
  // - 신발: size_text가 있으면 유효
  if ((height === 0 || weight === 0) && !sizeText) {
    return null;
  }

  return { height, weight, sizeText };
}

export function toSizeRecommendation(data?: SizeRecommendation | null): SizeRecommendationModel {
  return {
    recommendationType: data?.recommendation_type || PdpProductSizeType.NONE,
    recommendOptionValueList: toRecommendOptionValueList(data?.option_value_list || []),
    userAccount: data?.user_account
      ? {
          name: data.user_account.name || '',
          body: toUserAccountBody(data.user_account.body),
        }
      : null,
    userBodyInputInfo: data?.user_body_input_info
      ? {
          htmlTitle: data.user_body_input_info.html_title,
          selectionList: (data.user_body_input_info.selection_list || []).map((item) => ({
            key: item.key,
            label: item.label,
            min: item.min,
            max: item.max,
            gap: item.gap,
            measureUnit: item.measure_unit,
            selectedValue: item.selected_value || null,
            anchor: item.anchor,
            placeholder: item.placeholder,
          })),
        }
      : null,
    isReviewButtonVisible: data?.is_review_button_visible ?? false,
  };
}

export function toRecommendOptionValueList(list: Array<RecommendOptionValueList>): Array<RecommendOptionValueModel> {
  return list.map((item) => {
    return {
      ranking: item.ranking || 0,
      name: item.name || '',
      heightRange: {
        min: item.height_range?.min || 0,
        max: item.height_range?.max || 0,
      },
      weightRange: {
        min: item.weight_range?.min || 0,
        max: item.weight_range?.max || 0,
      },
      sizeWithCategory: item.size_with_category || '',
      answer: {
        percent: item.answer?.percent || 0,
        value: item.answer?.value || '',
      },
      purchasePercent: item.purchase_percent || 0,
    };
  });
}

